import Button from './Button'
import './Button.sass'

export default Button
